module.exports = __webpack_public_path__ + "resources/img/img_cubrid_02_en.ab08f169c3cec16e32f9ce930286c684.png";